"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METASITE_APP_DEF_ID = void 0;
exports.METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
//# sourceMappingURL=constants.js.map